import {AsyncPipe, DatePipe, NgClass} from '@angular/common';
import {Component, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {BreakpointService} from 'src/app/shared/services/breakpoint/breakpoint.service';
import {PrudentButtonComponent} from '../../prudent-button/prudent-button.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {DISPLAYABLE_DATE_FORMAT} from '../../../constants/date';

@Component({
  selector: 'app-previous-year-policy-dialog',
  imports: [
    AsyncPipe,
    NgClass,
    MatDialogContent,
    FormsModule,
    PrudentButtonComponent,
    DatePipe,
    NgSelectModule,
  ],
  templateUrl: './previous-year-poilcy-dialog.component.html',
  styleUrl: './previous-year-poilcy-dialog.component.scss',
})
export class PreviousYearPolicyDialogComponent {
  private breakpointService = inject(BreakpointService);
  deviceSize$ = this.breakpointService.deviceSize$;
  dialogRef = inject<MatDialogRef<PreviousYearPolicyDialogComponent>>(MatDialogRef);
  policyGroupId: string = inject<any>(MAT_DIALOG_DATA).policyGroupId;
  allPolicies = inject<any>(MAT_DIALOG_DATA).allPolicies;
  protected readonly DISPLAYABLE_DATE_FORMAT = DISPLAYABLE_DATE_FORMAT;

  selectPolicy() {
    this.dialogRef.close(this.policyGroupId);
  }
  close() {
    this.dialogRef.close();
  }
}
